import React from 'react';

type Props = {
  value: string;
};
export function CenterTrimmedValue({ value }: Props) {
  const lastPipeIdx = value.lastIndexOf('|');
  const firstPart = value.substring(0, lastPipeIdx);
  const lastPart = value.substring(lastPipeIdx);

  return (
    <div className="h-full w-full p-1">
      <div className="flex h-full w-full items-center rounded-sm bg-gray-100 px-2 py-0.5">
        <div className="flex h-full items-center overflow-hidden text-ellipsis whitespace-nowrap pr-2">
          {firstPart}
        </div>
        ...
        <div className="ml-2 flex h-full items-center border-l border-l-gray-200 pl-2">{`...${lastPart}`}</div>
      </div>
    </div>
  );
}
